import { createReducer } from '@reduxjs/toolkit';
import {
  setKioskErrorAction,
  setKioskLoadingAction,
  setKioskSessionAction,
  setKioskStatusAction,
} from 'store/actions/kiosk-session-actions';
import { IKioskState } from 'types/kiosk/IKioskState';
import { KioskStatus } from 'types/kiosk/KioskStatus';

const initialState: IKioskState = {
  status: KioskStatus.INACTIVE,
  session: null,
  loading: false,
  error: null,
};

const kioskSessionReducer = createReducer(initialState, builder => {
  builder
    .addCase(setKioskStatusAction, (state, action) => ({
      ...state,
      status: action.payload,
    }))
    .addCase(setKioskSessionAction, (state, action) => ({
      ...state,
      session: action.payload,
    }))
    .addCase(setKioskLoadingAction, (state, action) => ({
      ...state,
      loading: action.payload,
    }))
    .addCase(setKioskErrorAction, (state, action) => ({
      ...state,
      error: action.payload,
    }));
});

export default kioskSessionReducer;
